import { RootState } from '../store';
import { IdentityAuth, IdentityLoginResponse2User, IdentityAzureADAuth, IdentityLoginAuth } from '../../types/identity';

export const selectAuth = (state: RootState): IdentityAuth => state.auth;

export const selectAuthUser = (state: RootState): IdentityLoginResponse2User => state.auth.user; // user profile by binus
export const selectAuthUserAzureAD = (state: RootState): IdentityAzureADAuth => state.auth.userAzureAD; // user profile by azure ad token
